import { render, staticRenderFns } from "./advanced.vue?vue&type=template&id=48195a7a&"
import script from "./advanced.vue?vue&type=script&lang=js&"
export * from "./advanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports